import React, { FunctionComponent, useMemo, useState } from "react";
import { GameInfoProps } from "../../type";
import Utils from "../../utils";
import { NotFoundView } from "../not-found";
import { FreeSpinMode, Setting, Symbols } from "./type";
import GameUtils from "./utils";

export const DearSenpaiSettingView: FunctionComponent<GameInfoProps> = ({
  data,
}) => {
  const { currencies = [], payouts = {}, buyFreeSpinRate } = data as Setting;
  const [showCurrency, setShowCurrency] = useState(
    Object.values(currencies)[0]?.currency ?? ""
  );
  const currencySetting = useMemo(
    () => currencies.find((s) => s.currency === showCurrency),
    [showCurrency, currencies]
  );
  if (!currencySetting) return <NotFoundView />;
  Utils.setCurrencySymbol(currencySetting.symbol);
  return (
    <>
      <ul className="nav nav-pills mb-3">
        {Object.values(currencies).map((c) => (
          <li key={c.currency} className="nav-item">
            <button
              className={`nav-link${
                c.currency === showCurrency ? " active" : ""
              }`}
              onClick={() => {
                setShowCurrency(c.currency);
              }}
            >
              {c.currency}
            </button>
          </li>
        ))}
      </ul>
      <div className="table-responsive">
        <table className="table table-bordered table table-striped-columns">
          <colgroup>
            <col width={"5%"} />
            <col width={"5%"} />
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"10%"} />
            <col width={"50%"} />
          </colgroup>
          <thead>
            <tr>
              <th className="align-middle">Buy Free Spin Rate</th>
              <th className="align-middle">Bet Size Rate</th>
              <th className="align-middle">Min Bet</th>
              <th className="align-middle">Max Bet</th>
              <th className="align-middle">Max Bet with Buy Free Spin</th>
              <th className="align-middle">Symbol Multiplier</th>
              <th className="align-middle">Symbol Min Payout</th>
              <th className="align-middle">Symbol Max Payout</th>
              <th className="align-middle">Symbol Max Payout With Bonus</th>
              <th className="align-middle">Chip Options</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="align-middle">{buyFreeSpinRate}</td>
              <td className="align-middle">20%</td>
              <td className="align-middle">
                {Utils.asCurrency(currencySetting.minBet)}
              </td>
              <td className="align-middle">
                {Utils.asCurrency(currencySetting.maxBet)}
              </td>
              <td className="align-middle">
                {Utils.asCurrency(currencySetting.maxBet * buyFreeSpinRate)}
              </td>
              <td>
                {[
                  Symbols.Wild,
                  Symbols.Symbol1,
                  Symbols.Symbol2,
                  Symbols.Symbol3,
                  Symbols.Symbol4,
                  Symbols.Symbol5,
                  Symbols.Symbol6,
                  Symbols.Symbol7,
                ].map((symbol) => (
                  <div key={symbol} className="row">
                    <div className="col">
                      <div className="symbol">
                        {GameUtils.convertSymbol(+symbol, FreeSpinMode.None)}
                      </div>
                    </div>
                    <div className="col d-flex align-items-center">
                      <div>{GameUtils.symbolPayout(symbol)}</div>
                    </div>
                  </div>
                ))}
              </td>
              <td className="align-middle">
                {Utils.asCurrency(
                  currencySetting.minBet *
                    0.05 *
                    Math.min(...Object.values(payouts))
                )}
              </td>
              <td className="align-middle">
                {Utils.asCurrency(
                  Math.max(...currencySetting.chipOptions) *
                    0.05 *
                    36 * // all symbol count
                    Math.max(...Object.values(payouts))
                )}
              </td>
              <td className="align-middle">
                {Utils.asCurrency(
                  GameUtils.maxPayoutFormular(currencySetting.maxBet)
                )}
              </td>
              <td className="align-middle">
                {currencySetting.chipOptions
                  .map((c) => Utils.asCurrency(c))
                  .join(", ")}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};
